(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-faq-wrapper"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

  /* MAIN FAQ TOGGLE */
  const mainFaq = document.querySelector('.footer-faq-main');
  const categories = document.querySelector('.footer-faq-categories');

  mainFaq.addEventListener('click', () => {
    const open = categories.style.display === 'block';
    categories.style.display = open ? 'none' : 'block';
    mainFaq.querySelector('span').textContent = open ? '+' : '–';
  });

  /* CATEGORY TOGGLE */
  document.querySelectorAll('.footer-faq-category-title').forEach(title => {
    title.addEventListener('click', () => {
      const content = title.nextElementSibling;
      const icon = title.querySelector('span');
      const open = content.style.display === 'block';

      document.querySelectorAll('.footer-faq-category-content').forEach(c => c.style.display = 'none');
      document.querySelectorAll('.footer-faq-category-title span').forEach(i => i.textContent = '+');

      if (!open) {
        content.style.display = 'block';
        icon.textContent = '–';
      }
    });
  });

  /* QUESTION TOGGLE */
  document.addEventListener('click', e => {
    const q = e.target.closest('.footer-faq-question');
    if (!q) return;

    const a = q.nextElementSibling;
    const icon = q.querySelector('span');
    const open = a.style.display === 'block';

    document.querySelectorAll('.footer-faq-answer').forEach(ans => ans.style.display = 'none');
    document.querySelectorAll('.footer-faq-question span').forEach(i => i.textContent = '+');

    if (!open) {
      a.style.display = 'block';
      icon.textContent = '–';
    }
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-chatbot"] && !Shopify.designMode) return;
  try {
    

(function () {

  function setupHelpChatbot() {

    /* -------------------------------------------------------
       FIND HELP BUTTON
       ------------------------------------------------------- */

    const helpTrigger = document.getElementById('help-chat-trigger');
    const popup = document.getElementById('help-chat-popup');

    if (!popup) return;


    /* -------------------------------------------------------
       OPEN CHATBOT
       ------------------------------------------------------- */

    if (helpTrigger && !helpTrigger.dataset.helpChatBound) {

      helpTrigger.dataset.helpChatBound = 'true';

      helpTrigger.addEventListener('click', function (event) {

        event.preventDefault();
        event.stopPropagation();

        popup.classList.add('is-open');

        popup.setAttribute('aria-hidden', 'false');

      });

    }


    /* -------------------------------------------------------
       CLOSE BUTTON
       ------------------------------------------------------- */

    const closeButton = popup.querySelector('.help-chat-close');

    if (closeButton && !closeButton.dataset.helpChatBound) {

      closeButton.dataset.helpChatBound = 'true';

      closeButton.addEventListener('click', function () {

        popup.classList.remove('is-open');

        popup.setAttribute('aria-hidden', 'true');

      });

    }


    /* -------------------------------------------------------
       CLOSE WHEN CLICKING OUTSIDE CHAT BOX
       ------------------------------------------------------- */

    if (!popup.dataset.overlayBound) {

      popup.dataset.overlayBound = 'true';

      popup.addEventListener('click', function (event) {

        if (event.target === popup) {

          popup.classList.remove('is-open');

          popup.setAttribute('aria-hidden', 'true');

        }

      });

    }


    /* -------------------------------------------------------
       FAQ ACCORDION
       ------------------------------------------------------- */

    popup.querySelectorAll('.help-faq-question').forEach(function (question) {

      if (question.dataset.helpFaqBound) return;

      question.dataset.helpFaqBound = 'true';

      question.addEventListener('click', function () {

        const answer = question.nextElementSibling;

        if (!answer) return;


        /* Close all other answers */

        popup.querySelectorAll('.help-faq-answer').forEach(function (item) {

          if (item !== answer) {
            item.style.display = 'none';
          }

        });


        /* Toggle selected answer */

        if (answer.style.display === 'block') {

          answer.style.display = 'none';

        } else {

          answer.style.display = 'block';

        }

      });

    });

  }


  /* ---------------------------------------------------------
     INITIAL LOAD
     --------------------------------------------------------- */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      setupHelpChatbot,
      { once: true }
    );

  } else {

    setupHelpChatbot();

  }


  /* ---------------------------------------------------------
     SHOPIFY THEME EDITOR
     --------------------------------------------------------- */

  document.addEventListener(
    'shopify:section:load',
    setupHelpChatbot
  );

})();


  } catch(e) { console.error(e); }
})();
})();
